import {createError} from '../services/errors';
import config from 'config';
import {buildFetch} from '../services/fetch';
import Immutable from 'immutable';
import {i18n} from '@services/i18n';

// === QUESTIONS ===
export const QUESTIONS_LOADING_START = 'QUESTIONS_LOADING_START';
export const QUESTIONS_LOADING_SUCCESS = 'QUESTIONS_LOADING_SUCCESS';
export const QUESTIONS_LOADING_ERROR = 'QUESTIONS_LOADING_ERROR';
export const OUTCOME_SAVING_ERROR = 'OUTCOME_SAVING_ERROR';

export const loadQuestionsError = createError(QUESTIONS_LOADING_ERROR);
export const saveOutcomeError = createError(OUTCOME_SAVING_ERROR);

export function loadQuestionsStart() {
  return {
    type: QUESTIONS_LOADING_START,
  };
}

export function loadQuestionsSuccess(data = {}) {
  return {
    type: 'QUESTIONS_LOADING_SUCCESS',
    data,
  };
}

export const STORE_LOADING_START = 'STORE_LOADING_START';
export const STORE_LOADING_SUCCESS = 'STORE_LOADING_SUCCESS';
export const STORE_LOADING_ERROR = 'STORE_LOADING_ERROR';
export const RESET_EVALUATION = 'RESET_EVALUATION';

export function loadStoreStart() {
  return {
    type: STORE_LOADING_START,
  };
}

export function loadStoreSuccess(data = {}) {
  return {
    type: STORE_LOADING_SUCCESS,
    data,
  };
}

export function resetEvaluation() {
  return {
    type: RESET_EVALUATION,
  };
}

export const loadStoreError = createError('STORE_LOADING_ERROR');

export function loadStore({campaignId, evaluee}) {
  return function (dispatch) {
    const fetch = buildFetch(dispatch);
    dispatch(loadStoreStart());

    return fetch(`${config.api}/tests/360/data/${campaignId}/${evaluee}`)
      .then(response => {
        const version = response.data?.data?.version || 1;
        const data = response.data?.data?.testData;

        if (!data) {
          const store = {data: {}, version: 1};
          dispatch(loadStoreSuccess(store));
          return store;
        }

        try {
          const jsonDataStore = JSON.parse(data);
          const store = {data: jsonDataStore, version};
          dispatch(loadStoreSuccess(store));
          return store;
        } catch (error) {
          console.error('FAILED TO PARSE JSON');
        }
      })
      .catch(error => {
        if (!error) return;

        dispatch(loadStoreError(error.message));
        throw error;
      });
  };
}

export function saveLinkedAnswer({
  campaignId,
  evaluee,
  data,
  version,
  userId,
  questionId,
  onSuccess,
}) {
  return async function (dispatch) {
    const fetch = buildFetch(dispatch);

    dispatch(saveEvaluationStart());

    try {
      const parsedData = JSON.parse(data);
      const answers = parsedData[userId]
        .filter(
          data => data.questionId === questionId && data.value !== null && data.value !== undefined
        )
        .map(record => ({
          id: record.answerId,
          value: record.value,
        }));

      await fetch(`${config.api}/360/campaign/${campaignId}/questions/linked`, {
        method: 'POST',
        data: {data: {user: evaluee, id: questionId, answers}},
      });
      const res = await fetch(`${config.api}/tests/360/data/${campaignId}/${evaluee}`, {
        method: 'POST',
        data: {data, version: version + 1},
      });

      dispatch(loadStoreSuccess({data: parsedData, version: version + 1}));

      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    } catch (error) {
      dispatch(saveEvaluationError());
      dispatch(saveEvaluationErrorMessage(i18n._('notifications.password_reset_error_title')));
      console.log(error);
    }
  };
}

// === EVALUATION ===
export const EVALUATION_LOADING_START = 'EVALUATION_LOADING_START';
export const EVALUATION_LOADING_SUCCESS = 'EVALUATION_LOADING_SUCCESS';
export const EVALUATION_LOADING_ERROR = 'EVALUATION_LOADING_ERROR';

export const EVALUATION_SAVING_START = 'EVALUATION_SAVING_START';
export const EVALUATION_SAVING_SUCCESS = 'EVALUATION_SAVING_SUCCESS';
export const EVALUATION_SAVING_ERROR = 'EVALUATION_SAVING_ERROR';

export const loadEvaluationError = createError(EVALUATION_LOADING_ERROR);

export function loadEvaluationStart() {
  return {
    type: EVALUATION_LOADING_START,
  };
}

export function loadEvaluationSuccess(data = {}) {
  return {
    type: EVALUATION_LOADING_SUCCESS,
    data,
  };
}

export const saveEvaluationErrorMessage = createError(EVALUATION_SAVING_ERROR);

export function saveEvaluationStart() {
  return {
    type: EVALUATION_SAVING_START,
  };
}

export function saveEvaluationSuccess(data = {}) {
  return {
    type: EVALUATION_SAVING_SUCCESS,
    data,
  };
}

export function saveEvaluationError() {
  return {
    type: EVALUATION_SAVING_ERROR,
  };
}

export function loadQuestions({campaignId, evaluee}) {
  return function (dispatch) {
    const fetch = buildFetch(dispatch);
    dispatch(loadQuestionsStart());

    return fetch(`${config.api}/usercampaign/${campaignId}/questions/${evaluee}`)
      .then(response => {
        const data = Immutable.fromJS(response.data);

        dispatch(loadQuestionsSuccess(data));
        return data;
      })
      .catch(error => {
        if (!error) return;

        dispatch(loadQuestionsError(error.message));
        throw error;
      });
  };
}

export function loadEvaluation({campaignId, evaluee}) {
  return function (dispatch) {
    const fetch = buildFetch(dispatch);
    dispatch(loadEvaluationStart());

    return fetch(`${config.api}/usercampaign/${campaignId}/userrelation/${evaluee}`)
      .then(response => {
        const {result} = response.data;
        const data = Immutable.fromJS(result);

        dispatch(loadEvaluationSuccess(data));
        return data;
      })
      .catch(error => {
        if (!error) return;

        dispatch(loadEvaluationError(error.message));
        throw error;
      });
  };
}

export function saveOutcome({campaignId, evaluee, data, onSuccess}) {
  return function (dispatch, getState) {
    const fetch = buildFetch(dispatch);
    const state = getState();

    let evaluation = state.getIn(['evaluationQuestions', 'evaluation']);
    data.forEach(val => {
      const evaluationRecordIndex = evaluation.findIndex(
        item => item.get('questionId') === val.questionId
      );

      if (evaluationRecordIndex > -1) {
        evaluation = evaluation.setIn([evaluationRecordIndex, 'value'], val.value);
      } else {
        evaluation = evaluation.push(Immutable.fromJS({...val, evaluatedId: evaluee}));
      }
    });

    dispatch(saveEvaluationStart());

    return fetch(`${config.api}/usercampaign/${campaignId}/outcomes/${evaluee}`, {
      method: 'POST',
      data,
    })
      .then(response => {
        dispatch(saveEvaluationSuccess(evaluation));

        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess();
        }
      })
      .catch(error => {
        dispatch(saveEvaluationError());
        dispatch(saveEvaluationErrorMessage(i18n._('notifications.password_reset_error_title')));

        if (!error) return;

        dispatch(saveOutcomeError(error.message));
        throw error;
      });
  };
}
